'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('gaptitude', {
      url: '/gamedata/gaptitude',
      template: '<gaptitude></gaptitude>'
    });
}
